import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';

const Header = ({ 
  currentPage = 'System Core', 
  onProfileClick, 
  onMobileMenuToggle,
  showMobileMenu = true,
  onProfileImageClick // New prop for profile image upload
}) => {
  const { user } = useSelector((state) => state.auth);
  const [forceUpdate, setForceUpdate] = useState(0);

  // Listen for profile image updates to force re-render
  useEffect(() => {
    const handleProfileImageUpdate = () => {
      setForceUpdate(prev => prev + 1);
    };

    window.addEventListener('profileImageUpdated', handleProfileImageUpdate);
    return () => {
      window.removeEventListener('profileImageUpdated', handleProfileImageUpdate);
    };
  }, []);

  return (
    <header className="h-16 md:h-20 bg-white/70 backdrop-blur-xl sticky top-0 border-b border-gray-100 px-4 md:px-10 flex items-center justify-between z-30 shrink-0">
      <div className="flex items-center gap-3 md:gap-6">
        {showMobileMenu && (
          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-xl bg-gray-50 text-bulky-navy-500"
            onClick={onMobileMenuToggle}
          >
            <span className="material-icons-round">menu</span>
          </button>
        )}
        <h2 className="font-medium">
          {currentPage}
        </h2>
        <div className="hidden md:block h-6 w-[2px] bg-gray-100"></div>
        <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-gray-50 rounded-lg border border-gray-100">
          <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full shadow-[0_0_8px_rgba(16,185,129,0.5)]"></div>
          <span className="text-[9px] font-normal text-bulky-navy-400 uppercase tracking-wider">Protocol Stable</span>
        </div>
      </div>

      <div className="flex items-center gap-4 md:gap-6">
        <div 
          className="flex items-center gap-3 md:gap-4 cursor-pointer hover:bg-gray-50 rounded-xl p-2 transition-all"
          onClick={onProfileClick}
        >
          <div className="text-right hidden sm:block">
            <p className="text-xs font-normal text-bulky-navy-800 uppercase tracking-tighter leading-none mb-1 truncate max-w-[120px]">
              {user?.firstName && user?.lastName 
                ? `${user.firstName} ${user.lastName}` 
                : user?.name || user?.username}
            </p>
            <p className="text-[8px] text-bulky-blue-500 font-normal uppercase tracking-[0.3em]">Verified Authority</p>
          </div>
          <div 
            className="relative group"
            onClick={(e) => {
              e.stopPropagation(); // Prevent triggering onProfileClick
              if (onProfileImageClick) {
                onProfileImageClick();
              }
            }}
          >
            <div className="absolute -inset-1 bg-bulky-blue-500 rounded-xl blur opacity-10 group-hover:opacity-30 transition"></div>
            {user?.profile_image || user?.profileImage ? (
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-xl border-2 border-white shadow-2xl relative z-10 transition-transform group-hover:rotate-[5deg] overflow-hidden">
                <img
                  key={`${user.profile_image || user.profileImage}-${forceUpdate}`} // Force re-render when image changes
                  src={user.profile_image || user.profileImage}
                  alt="Profile"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    // Fallback to initials if image fails to load
                    e.target.parentElement.innerHTML = `
                      <div class="w-full h-full bg-gradient-to-br from-bulky-blue-400 to-bulky-blue-600 flex items-center justify-center text-white font-normal text-sm md:text-base">
                        ${(user?.firstName || user?.name || user?.username)?.[0]?.toUpperCase() || 'U'}
                      </div>
                    `;
                  }}
                />
              </div>
            ) : (
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-xl bg-gradient-to-br from-bulky-blue-400 to-bulky-blue-600 border-2 border-white flex items-center justify-center text-white shadow-2xl font-normal text-sm md:text-base relative z-10 transition-transform group-hover:rotate-[5deg]">
                {(user?.firstName || user?.name || user?.username)?.[0]?.toUpperCase()}
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;